import { 
    useEffect, 
    useCallback, 
    MouseEvent } from 'react';
import { useStore } from '@ui/hooks/useStore';
import { KeyboardEventHandler } from 'react';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import useKeyDown from '@ui/hooks/useKeyDown';


const useExistOldLogin = (onClose: ICloseEvent['onClose']) => {
    const { devices, lang, user, app } = useStore();
    const key = useKeyDown();

    const handleSignInClick = useCallback(
        async (e?: MouseEvent<HTMLButtonElement>) => {
        if (e) e.preventDefault();
        user.loginActive = false;
        app.isOpenModalAddOldDevice = false;
        onClose();    
    }, [])

    const handleBtnKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
        const { key } = e;
        if (key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            handleKey(key)
        }
    };

    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                user.loginActive = false;
                onClose();
                break;
            case 'Enter':
                user.loginActive = false;
                onClose();
                break;
        }
    };

    const handlers = {
        handleSignInClick,
        handleBtnKeyDown
    }

    useEffect(() => {
        handleKey(key);
    }, [key]);
        
    return {
        lang,
        user,
        devices,
        handlers  
    };
};

export default useExistOldLogin;
